
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/academy/[slug]",
      function () {
        return require("private-next-pages/d/academy/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/academy/[slug]"])
      });
    }
  